export default "__VITE_ASSET__C9Zsx5lY__"